export const text = {
  en: {
    '.js-queue': 'ADD TO QUEUE',
    '.js-watch': 'ADD TO WATCHED',
    '.queued': 'QUEUE',
    '.watched': 'WATCHED',
    '.zsu': 'SUPPORT UKRAINE',
    '.home': 'HOME',
    '.library': 'MY LIBRARY',
  },
  ua: {
    '.js-queue': 'ДОДАТИ В ЧЕРГУ',
    '.js-watch': 'ДОДАТИ В ПЕРЕГЛЯНУТІ',
    '.queued': 'В ЧЕРЗІ',
    '.watched': 'ПЕРЕГЛЯНУТІ',
    '.zsu': 'ДОПОМОГА ЗСУ',
    '.home': 'ГОЛОВНА',
    '.library': 'МОЯ БІБЛІОТЕКА',
  },
}